import VueRouter from 'vue-router'
import store from "../store";
import {GetBaseMenu, GetPersonMenu} from "../api/user";
import {GetBaseInfo} from "../api";

const routers = {
  '@/views/index': () => import('@/views/public/Index'),
  '@/views/login': () => import('@/views/public/LoginNew'),
  '@/views/user/user_info': () => import('@/views/user/UserInfo'),
  '@/views/user/user_ads_data': () => import('@/views/user/UserAdsData'),
  '@/views/user/user_ads_mouth_data': () => import('@/views/user/UserAdsMouthData'),
  '@/views/user/update_password': () => import('@/views/user/UserPassword'),
  '@/views/system_config/product': () => import('@/views/system/config/ProductConfig'),
  '@/views/system_config/product_user': () => import('@/views/system/config/ProductUserConfig'),
  '@/views/system_config/watermark': () => import('@/views/system/config/WatermarkConfig'),
  '@/views/system_config/need': () => import('@/views/system/config/NeedConfig'),
  '@/views/system_auth/menu': () => import('@/views/system/auth/Menu'),
  '@/views/system_auth/api': () => import('@/views/system/auth/Api'),
  '@/views/system_admin/user': () => import('@/views/system/admin/User'),
  '@/views/system_admin/user_group': () => import('@/views/system/admin/UserGroup'),
  '@/views/testing/material': () => import('@/views/testing/material/MaterialTestingIndex'),
  '@/views/testing/material/create': () => import('@/views/testing/material/MaterialTestingCreate'),
  '@/views/testing_video': () => import('@/views/testing/video/TestingVideoIndex'),
  '@/views/ads_video': () => import('@/views/ads_video/AdsVideoIndex'),
  '@/views/ads_video_data': () => import('@/views/ads_video/AdsVideoData'),
  '@/views/ads_video_delete': () => import('@/views/ads_video/AdsVideoDelete'),
  '@/views/ads_video_task': () => import('@/views/ads_video/AdsVideoTask'),
  '@/views/ads_video_task_create': () => import('@/views/ads_video/AdsVideoTaskCreate'),
  '@/views/ads_video_data_list': () => import('@/views/V4/ads_video/AdsVideoDataList'),
  '@/views/ads_video_data_date': () => import('@/views/V4/ads_video/AdsVideoDataDate'),
  '@/views/ads_video_data_need': () => import('@/views/V4/ads_video/AdsVideoDataNeed'),
  '@/views/template': () => import('@/views/template/template/TemplateIndex'),
  '@/views/template/left_right': () => import('@/views/template/template/LeftRight'),
  '@/views/template/before_after': () => import('@/views/template/template/BeforeAfter'),
  '@/views/template/top_bottom': () => import('@/views/template/template/TopBottom'),
  '@/views/template/stuck_point': () => import('@/views/template/template/StuckPoint'),
  '@/views/task': () => import('@/views/template/task/TaskIndex'),
  '@/views/task/stuck_point': () => import('@/views/template/task/CreateStuckPointTask'),
  '@/views/baselib': () => import('@/views/template/baselib/BaselibIndex'),
  '@/views/baselib/video': () => import('@/views/template/baselib/BaselibVideo'),
  '@/views/baselib/image': () => import('@/views/template/baselib/BaselibImage'),
  '@/views/baselib/music': () => import('@/views/template/baselib/BaselibMusic'),
  '@/views/baselib/official': () => import('@/views/template/baselib/BaselibOfficial'),
  '@/views/baselib/tags': () => import('@/views/template/baselib/BaselibTags'),
  '@/views/baselib/create': () => import('@/views/template/baselib/BaselibCreate'),
  '@/views/resize_video': () => import('@/views/resize_video/in/ResizeVideo'),
  '@/views/resize_video/in': () => import('@/views/resize_video/in/ResizeVideo'),
  '@/views/resize_video/in/background': () => import('@/views/resize_video/in/ResizeVideoBackground'),
  '@/views/resize_video/in/pip_temp': () => import('@/views/resize_video/in/ResizeVideoPipTem'),
  '@/views/resize_video/in/official': () => import('@/views/resize_video/in/ResizeVideoOfficial'),
  '@/views/resize_video/in/official_temp': () => import('@/views/resize_video/in/ResizeVideoOfficialTem'),
  '@/views/resize_video/out': () => import('@/views/resize_video/out/ResizeBackground'),
  '@/views/resize_video/out/background': () => import('@/views/resize_video/out/ResizeBackground'),
  '@/views/resize_video/out/language': () => import('@/views/resize_video/out/ResizeLanguage'),
  '@/views/resize_video/out/gaussian': () => import('@/views/resize_video/out/ResizeGaussian'),
  '@/views/resize_video/out/filter': () => import('@/views/resize_video/out/ResizeFilter'),
  '@/views/resize_video/out/pip': () => import('@/views/resize_video/out/ResizePip'),
  '@/views/resize_video/batch': () => import('@/views/resize_video/batch/BatchIndex'),
  '@/views/resize_video/batch/info': () => import('@/views/resize_video/batch/BatchInfo'),
  '@/views/resize_video/batch/create': () => import('@/views/resize_video/batch/BatchCreate'),
  '@/views/scenes': () => import('@/views/scenes/ScenesIndex'),
  '@/views/scenes/scenes_source': () => import('@/views/scenes/ScenesSource'),
  '@/views/scenes/scenes_source/create': () => import('@/views/scenes/ScenesSourceCreate'),
  '@/views/scenes/scenes_temp': () => import('@/views/scenes/ScenesTemp'),
  '@/views/scenes/scenes_temp/create': () => import('@/views/scenes/ScenesTempCreate'),
  '@/views/scenes/scenes_task': () => import('@/views/scenes/ScenesTask'),
  '@/views/scenes/scenes_task/create': () => import('@/views/scenes/ScenesTaskCreate'),
  '@/views/scenes/scenes_task/detail': () => import('@/views/scenes/ScenesTaskDetail'),
  '@/views/end_card': () => import('@/views/end_card/EndCardIndex'),
  '@/views/end_card/create': () => import('@/views/end_card/EndCardCreate'),
  '@/views/end_card/out': () => import('@/views/end_card/EndCardOut'),
  '@/views/end_card/task': () => import('@/views/end_card/EndCardTask'),
  '@/views/drop_image': () => import('@/views/drop_image/DropImageData'),
  '@/views/drop_image_library': () => import('@/views/drop_image/DropImageLibrary'),
  '@/views/drop_image/synthesis_temp': () => import('@/views/synthesis_image/SynthesisTemp'),
  '@/views/drop_image/synthesis_temp_create': () => import('@/views/synthesis_image/SynthesisTempCreate'),
  '@/views/drop_image/synthesis_source': () => import('@/views/synthesis_image/SynthesisSource'),
  '@/views/drop_image/synthesis_image': () => import('@/views/synthesis_image/SynthesisImage'),
  '@/views/drop_image/synthesis_image_create': () => import('@/views/synthesis_image/SynthesisImageCreate'),
  '@/views/data_center': () => import('@/views/data_center/DataIndex'),
  '@/views/data_center/index': () => import('@/views/data_center/DataIndex'),
  '@/views/data_center/producer': () => import('@/views/data_center/DataProducer'),
  '@/views/data_center/product': () => import('@/views/data_center/DataProduct'),
  '@/views/data_center/tags': () => import('@/views/data_center/DataTags'),
  '@/views/data_center/pk': () => import('@/views/data_center/PkData'),
  '@/views/download_music/DownloadMusic': () => import('@/views/download_music/DownloadMusic'),
  '@/views/need/index': () => import('@/views/need/NeedIndex'),
  '@/views/need/index_panel': () => import('@/views/need/NeedIndexPanelV2'),
  '@/views/need/item': () => import('@/views/need/NeedItem'),
  '@/views/need/item_panel': () => import('@/views/need/NeedItemPanelV2'),
  '@/views/need/video_script': () => import('@/views/need/VideoScript'),
  '@/views/need/need_pool': () => import('@/views/need/NeedPool'),
  '@/views/need/tag': () => import('@/views/V5/demand_platform/NeedTagV5'),
  '@/views/need/count': () => import('@/views/V4/demand_platform/NeedCount'),
  '@/views/need/push_count': () => import('@/views/V5/demand_platform/NeedPushCountV5'),
  '@/views/demand/user_spend': () => import('@/views/demand_platform/UserSpend'),
  '@/views/demand/product_spend': () => import('@/views/demand_platform/ProductSpend'),
  '@/views/demand/count': () => import('@/views/demand_platform/NeedCount'),
  '@/views/demand/script': () => import('@/views/demand_platform/VideoScriptV3'),
  '@/views/demand/index': () => import('@/views/V5/demand_platform/NeedIndexPanelV5'),//分配需求
  '@/views/demand/add': () => import('@/views/V5/demand_platform/NeedBaseV5'),//新增需求
  '@/views/demand/item': () => import('@/views/V5/demand_platform/NeedItemPanelV5'),//执行需求
  '@/views/demand/check': () => import('@/views/V5/demand_platform/NeedCheckV5'),//审核需求
  '@/views/demand/comment': () => import('@/views/demand_platform/NeedCommentV3'),
  '@/views/demand/image': () => import('@/views/demand_platform/NeedImage'),
  '@/views/demand/translate_list': () => import('@/views/demand_platform/TranslateList'),//翻译集合
  '@/views/batch_resize/index': () => import('@/views/batch_resize/BatchResizeIndex'),
  '@/views/batch_resize/list': () => import('@/views/batch_resize/BatchResizeList'),
  '@/views/synthesis/temp': () => import('@/views/synthesis/Temp'),
  '@/views/synthesis/create_temp': () => import('@/views/synthesis/CreateTemp'),
  '@/views/synthesis/source': () => import('@/views/synthesis/Source'),
  '@/views/synthesis/create': () => import('@/views/synthesis/Synthesis'),
  '@/views/synthesis/out': () => import('@/views/synthesis/Out'),
  '@/views/source/image': () => import('@/views/source_manage/ImageData'),
  '@/views/source/playable': () => import('@/views/source_manage/PlayableData'),
  '@/views/source/ue': () => import('@/views/source_manage/UeData'),
  '@/views/source/excellent_material': () => import('@/views/source_manage/ExcellentMaterial'),
}

const router = new VueRouter({
  mode:'history'
})

router.beforeEach((to,from,next)=>{
  const base_info_status = router.app.$store.state.base_info_status
  if (to.query.user_id&&to.query.token)
    router.app._set_login(to.query.user_id,to.query.token)
  if (base_info_status===false){
    GetBaseInfo({}).then(resp => {
      router.app.$store.commit('setBaseInfoStatus', true)
      // router.app.$store.commit('setSourceHost', resp.data.sourceHost)
      router.app.$store.commit('setProductList', resp.data.productList)
      router.app.$store.commit('setCountryList', resp.data.countryList)
      router.app.$store.commit('setLanguageList', resp.data.languageList)
      router.app.$store.commit('setPushChannelList', resp.data.pushChannelList)
      router.app.$store.commit('setMaterialTypeList', resp.data.materialTypeList)
      router.app.$store.commit('setMaterialImageSizeList', resp.data.materialImageSizeList)
      router.app.$store.commit('setMaterialSizeList', resp.data.materialSizeList)
      const menu = router.app.$store.state.menu
      if (menu.length==0){
        let login_info = router.app._get_login()
        if (login_info.code!==200){
          GetBaseMenu({}).then(resp => {
            if (resp.code===200){
              router.app.$store.commit('setMenu',resp.data)
              let menu = []
              menu = router.app._get_init_menu(resp.data,menu)
              let now_menu_info = menu.find(item=>item.url===to.path)
              if (now_menu_info!==undefined){
                Object.keys(now_menu_info.now_menu).forEach(function (item) {
                  router.app.$store.commit('setNowMenu', [item,now_menu_info.now_menu[item]])
                })
              }
              menu = menu.map(function (currentValue,index,arr) {
                return { path: currentValue.url, component: routers[currentValue.component] }
              })
              router.addRoutes(menu)
              next({ ...to, path: '/login', replace: true })
            }
          })
        }else{
          let user_id = login_info.data.user_id
          let token = login_info.data.token
          GetPersonMenu({user_id:user_id,token:token}).then(resp => {
            if (resp.code===200){
              router.app.$store.commit('setMenu',resp.data)
              let menu = []
              menu = router.app._get_init_menu(resp.data,menu)
              let now_menu_info = menu.find(item=>item.url===to.path)
              if (now_menu_info!==undefined){
                Object.keys(now_menu_info.now_menu).forEach(function (item) {
                  router.app.$store.commit('setNowMenu', [item,now_menu_info.now_menu[item]])
                })
              }
              menu = menu.map(function (currentValue,index,arr) {
                return { path: currentValue.url, component: routers[currentValue.component] }
              })
              router.addRoutes(menu)
              next({ ...to, replace: true })
            }
          })
        }
      }else{
        let menu = router.app.$store.state.menu
        menu = router.app._get_init_menu(menu,[])
        let now_menu_info = menu.find(item=>item.url===to.path)
        if (now_menu_info!==undefined){
          Object.keys(now_menu_info.now_menu).forEach(function (item) {
            router.app.$store.commit('setNowMenu', [item,now_menu_info.now_menu[item]])
          })
        }
        next()
      }
    })
  }
  else {
    const menu = router.app.$store.state.menu
    if (menu.length==0){
      let login_info = router.app._get_login()
      if (login_info.code!==200){
        GetBaseMenu({}).then(resp => {
          if (resp.code===200){
            router.app.$store.commit('setMenu',resp.data)
            let menu = []
            menu = router.app._get_init_menu(resp.data,menu)
            let now_menu_info = menu.find(item=>item.url===to.path)
            if (now_menu_info!==undefined){
              Object.keys(now_menu_info.now_menu).forEach(function (item) {
                router.app.$store.commit('setNowMenu', [item,now_menu_info.now_menu[item]])
              })
            }
            menu = menu.map(function (currentValue,index,arr) {
              return { path: currentValue.url, component: routers[currentValue.component] }
            })
            router.addRoutes(menu)
            next({ ...to, path: '/login', replace: true })
          }
        })
      }else{
        let user_id = login_info.data.user_id
        let token = login_info.data.token
        GetPersonMenu({user_id:user_id,token:token}).then(resp => {
          if (resp.code===200){
            router.app.$store.commit('setMenu',resp.data)
            let menu = []
            menu = router.app._get_init_menu(resp.data,menu)
            let now_menu_info = menu.find(item=>item.url===to.path)
            if (now_menu_info!==undefined){
              Object.keys(now_menu_info.now_menu).forEach(function (item) {
                router.app.$store.commit('setNowMenu', [item,now_menu_info.now_menu[item]])
              })
            }
            menu = menu.map(function (currentValue,index,arr) {
              return { path: currentValue.url, component: routers[currentValue.component] }
            })
            router.addRoutes(menu)
            next({ ...to, replace: true })
          }
        })
      }
    }else{
      let menu = router.app.$store.state.menu
      menu = router.app._get_init_menu(menu,[])
      let now_menu_info = menu.find(item=>item.url===to.path)
      if (now_menu_info!==undefined){
        Object.keys(now_menu_info.now_menu).forEach(function (item) {
          router.app.$store.commit('setNowMenu', [item,now_menu_info.now_menu[item]])
        })
      }
      next()
    }
  }
})

export default router



// export default new Router({
//   routes: [
//     {
//       path: '/',
//       name: 'index',
//       component: Index
//     },
//     {
//       path: '/login',
//       name: 'login',
//       component: Login
//     }
//   ]
// })



// WEBPACK FOOTER //
// ./src/router/index.js